import { AssignmentsV3Document } from '@/store/v2';
import { useQuery } from '@apollo/client';

import { AssignmentsV3QueryResult } from '@/store/assignments/types';
import { transformResults } from '@/store/assignments/shared/utils';
import { UseAssignmentsHook } from './types';

export const useAssignments: UseAssignmentsHook = ({ userIds, teamsIds, spaces, searchPhrase, status, sort, type, skip }) => {
  const spacesIds = spaces?.map((space) => space.id) ?? null;

  const { data, loading, error, refetch } = useQuery<AssignmentsV3QueryResult>(AssignmentsV3Document, {
    variables: {
      selectCards: true,
      spacedIdsIN: spacesIds,
      searchPhrase: searchPhrase ?? null,
      userIdIN: userIds,
      userTeamIdIN: teamsIds ?? null,
      status: status ?? null,
      sort: sort ?? null,
      type: type ?? null,
      pagination: {
        limit: -1,
        page: 1,
      },
    },
    skip,
  });

  return {
    data: data?.assignmentsV3.data ? data?.assignmentsV3.data.map((x) => transformResults(x, userIds ?? [])) : [],
    loading,
    error,
    refetch,
  };
};
